import customerImg from "../../../assets/img/apponboarding/customer.png";
import StepCard from "./components/StepCard";


const StepAddCustomer = ({
  onCtaClick,
  onSkip,
  stepNumber,
  selectedOrganization,
}) => (
  <StepCard
    stepLabel={`Step ${stepNumber}`}
    title="Add Your First Customer"
    description="Create a customer profile to attach jobs, invoices, and history in one place."
    ctaLabel="Add Customer"
    onCtaClick={onCtaClick}
    onSkip={onSkip}
    mediaSrc={null}
    selectedOrganization={selectedOrganization}
    backgroundColor="#F4ECFE"
    backgroundImage={customerImg}
    videoUrl="https://youtu.be/0ipv-E8p_U0"
  />
);

export default StepAddCustomer;